import { render, staticRenderFns } from "./PublishingContractsTopSlot.vue?vue&type=template&id=459990e8"
import script from "./PublishingContractsTopSlot.vue?vue&type=script&lang=js"
export * from "./PublishingContractsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports